module.exports = __webpack_public_path__ + "img/8d62239.png";